
























































































































import Vue, { PropType } from 'vue';
import { Module } from '@/models/configurator/module';
import { cloneDeep } from 'lodash';
import ModuleImage from './ModuleImage.vue';
import VNodes from '@/components/computation/VNodes.vue';
import ModuleDetailMenu from './ModuleDetailMenu.vue';

export default Vue.extend({
  name: 'ModuleList',

  components: { ModuleImage, VNodes, ModuleDetailMenu },

  props: {
    modules: Array as PropType<Module[]>,
    search: String as PropType<string>,
    cloneIndex: Number as PropType<number>
  },

  data() {
    return {
      loading: false,

      headers: [
        {
          text: '',
          sortable: false,
          align: 'center',
          value: 'image',
          width: 50,
          class: 'px-0'
        },
        { text: 'Name', sortable: false, value: 'name' },

        {
          text: '',
          sortable: false,
          align: 'center',
          value: 'is_published'
        },

        {
          sortable: false,
          align: 'center',
          value: 'actions'
        }
      ]
    };
  },

  computed: {
    moduleIsCloning() {
      return this.cloneIndex > -1;
    }
  },

  methods: {
    itemClass(item: Module) {
      if (!item.is_published) {
        return 'item--disabled';
      }
    },

    editModule(module: Module) {
      this.$emit('edit-module', cloneDeep(module));
    },

    deleteModule(id: number) {
      this.$emit('delete-module', id);
    },

    cloneModule(module: Module, index: number) {
      this.$emit('clone-module', { module, index });
    },

    goToModuleDetail(module: Module) {
      if (this.moduleIsCloning) return;
      return this.$router.push({
        name: 'module-detail',
        params: { moduleId: String(module.id) }
      });
    }
  }
});
